import logo from './logo.svg';
import './App.css';
import MatrixRain from './Rain';

function App() {
  return (
    <div className="App">
      <MatrixRain />
    </div>
  );
}

export default App;
